module.exports = __webpack_public_path__ + "static/media/paleta.8c5b93e6.jpeg";